/* eslint-disable */
const getters = {
  getVideo(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
